import Joi from 'joi-browser'

export const getDataSchema = (key, isRequired = true) => {
  return Joi.object().keys({
    [key]: isRequired ? Joi.string().required() : Joi.string()
  })
}

export const getAnySchema = (key, isRequired = true) => {
  return Joi.object().keys({
    [key]: isRequired
      ? Joi.any()
        .required()
        .invalid(['', null])
      : Joi.any().invalid(['', null])
  })
}

export const getNumberSchema = (key, isRequired = true) => {
  return Joi.object().keys({
    [key]: isRequired ? Joi.number().required() : Joi.number()
  })
}

export const getBooleanSchema = (key, isRequired = true) => {
  return Joi.object().keys({
    [key]: isRequired ? Joi.boolean().required() : Joi.boolean()
  })
}

export const getTripTypeSchema = () => {
  return Joi.object().keys({
    tripType: Joi.string().valid(['one-way', 'round-trip', 'multi-destination'])
  })
}

export const getRoomsSchema = () => {
  return Joi.object().keys({
    rooms: Joi.string().valid([
      '1 room',
      '2 rooms',
      '3 rooms',
      '4 rooms',
      '5 rooms',
      '6 rooms',
      '7 rooms',
      '8 rooms',
      '9 rooms',
      '10+ rooms'
    ])
  })
}

export const getCabinClassSchema = () => {
  return Joi.object().keys({
    cabinClass: Joi.string().valid([
      'Economy',
      'Premium Economy',
      'Business',
      'First'
    ])
  })
}

export const getProductTypeSchema = () => {
  return Joi.object().keys({
    productType: Joi.string().valid([
      'FLY',
      'FLY:STAY',
      'FLY:DRIVE',
      'FLY:STAY:DRIVE',
      'FLY:DRIVE:STAY'
    ])
  })
}

export const getInfantsCountSchema = allowedCodes => {
  return Joi.object().keys({
    infantsCount: Joi.number().required(),
    countryCode: allowedCodes
      ? Joi.when('infantsCount', {
        is: Joi.number().greater(0),
        then: Joi.valid(allowedCodes)
      })
      : Joi.string().allow('')
  })
}

export const getCalendarSchema = config => {
  const inputSchema = Joi.object().keys({
    keys: Joi.array().items(
      Joi.object().keys({
        name: Joi.string().required(),
        isRequired: Joi.boolean().required()
      }),
      Joi.object().keys({
        name: Joi.string().required(),
        isDisabled: Joi.boolean().required()
      })
    )
  })

  const rs = inputSchema.validate(config)
  if (rs.error) {
    throw rs.error
  }

  const keys = config.keys
  const schemaConfig = {
    [keys[0].name]: keys[0].isRequired
      ? Joi.date()
        .timestamp()
        .required()
      : Joi.date()
        .timestamp()
        .allow(['', null]),
    [keys[1].name]: keys[1].isDisabled
      ? Joi.any()
      : Joi.date()
        .timestamp()
        .when(keys[0].name, {
          is: Joi.date().timestamp(),
          then: Joi.date().timestamp(),
          otherwise: Joi.allow('')
        })
  }
  return Joi.object().keys(schemaConfig)
}

export const getAirportSchema = config => {
  const inputSchema = Joi.object().keys({
    key: Joi.string().required(),
    infantsCount: Joi.number().required()
  })

  const rs = inputSchema.validate(config)
  if (rs.error) {
    throw rs.error
  }
  const { key, infantsCount } = config
  return Joi.object().keys({
    [key]: infantsCount
      ? Joi.object({
        countryCode: Joi.string().valid('US'),
        itemName: Joi.string().required()
      })
        .unknown()
        .required()
      : Joi.object({
        itemName: Joi.string().required()
      })
        .unknown()
        .required(),
    otherAirport: Joi.object({
      itemName: Joi.string().invalid(Joi.ref(`${key}.itemName`)) // this should blacklist a string, by reference but is not working
    }).unknown()
  })
}
